












import VueOptions from '@utils/VueOptions'

settings = {}

export default VueOptions.vue settings
